


























































































































































































































































































































































import { Vue, Component, Mixins } from "vue-property-decorator";
import moment from "moment";
import filesaver from "file-saver";
import MyList from "@/mixins/list";

import SelectStadium from "@/components/selectstadium.vue";

import OrderDetail from "../bill/detail.vue";

import { getColor, fromSourceList } from "@/libs/colors";

@Component({
  components: {
    OrderDetail,
    SelectStadium
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "users/getUsers";

  orderDetailModalVisible = false;

  selectedRowKeys: any[] = [];
  fromSourceList: any[] = fromSourceList;

  paychannels: any[] = [];

  balanceTotal = 0;

  withdrawModal=false;
  withdrawUser={id:0,balance:0,username:'',mobile:''};

  // 操作搜索栏的展开和折叠
  isFlag = false;

  // columns: any[] = [
  //   {
  //     title: "编号",
  //     dataIndex: "id",
  //   },
  //   { title: "头像", scopedSlots: { customRender: "avatar" } },
  //   {
  //     title: "用户名",
  //     scopedSlots: { customRender: "username" },
  //   },
  //   { title: "城市", dataIndex: "city_name" },
  //   { title: "场馆名称", dataIndex: "stadium_name" },
  //   { title: "类型", scopedSlots: { customRender: "type" } },
  //   { title: "充值金额（元）", scopedSlots: { customRender: "fee" } },
  //   { title: "余额", scopedSlots: { customRender: "balance" } },
  //   { title: "充值方式", dataIndex: "channel_name" },
  //   { title: "充值时间", dataIndex: "created_time" },
  //   { title: "状态", scopedSlots: { customRender: "is_pay" } },
  //   { title: "操作", scopedSlots: { customRender: "action" } },
  // ];

  columns: any[] = [
    {
      title: "编号",
      dataIndex: "id"
    },
    {
      title: "头像",
      scopedSlots: { customRender: "avatar" }
    },
    {
      title: "会员名称（昵称）",
      scopedSlots: { customRender: "username" }
    },
    {
      title: "手机号（归属地）",
      scopedSlots: { customRender: "mobile" }
    },
    {
      title: "来源",
      scopedSlots: { customRender: "from_source" }
    },
    {
      title: "羽约余额",
      scopedSlots: { customRender: "balance" }
    },
    // {
    //   title: "积分",
    //   dataIndex: "score",
    // },
    {
      title: "注册时间/注册场馆",
      scopedSlots: { customRender: "created_time" }
    },
    {
      title: "C端首次登录",
      scopedSlots: { customRender: "first_login_c" }
    },
    {
      title: "B端首次登录",
      scopedSlots: { customRender: "first_login_b" }
    },
    // {
    //   title: '性别',
    //   scopedSlots: { customRender: 'sex' }
    // },
    // {
    //   title: '实名认证',
    //   scopedSlots: { customRender: 'identity_status' }
    // },
    {
      title: "订场次数/最近订场",
      scopedSlots: { customRender: "order_count" }
    },

    // {
    //   title: '注册来源场馆',
    //   dataIndex: 'from_stadium'
    // },
    {
      title: "打球次数/最后活动场馆",
      scopedSlots: { customRender: "stadium_name" }
    },

    {
      title: "操作",
      scopedSlots: { customRender: "action" }
    }
  ];

  getColor(fromSource: number): string {
    return getColor(fromSource);
  }

  mounted() {
    // this.loadPaymentChannel();
    // this.searchData.trade_type = '2'
    this.loadData({
      trade_type: 2,
      stype: "yuyue-balance"
    });

    this.$store.dispatch("users/balanceTotal").then(res => {
      console.log("balanceTotal", res);
      if (res && res.Data) {
        this.balanceTotal = res.Data;
      }
    });
  }

  handleTableSearch1(e: any) {
    e.preventDefault();
    this.selectedRowKeys = [];
    this.handleTableSearch(e);
  }

  async loadPaymentChannel() {
    const res = await this.$store.dispatch("bill/getPayChannels", {});
    if (res && res.Data) {
      this.paychannels = res.Data;
    }
  }

  async exportExcel() {
    this.$confirm({
      title: "确认信息",
      content: "确认导出吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("payments/export", {
          ...this.reloadQueryData
        });
        // console.log(res)
        if (res && res.data) {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          filesaver.saveAs(blob, `充值记录${moment().format("YYYY-MM-DD HH:mm:ss")}.xlsx`);
        }
      }
    });
  }

  showOrderDetailModal(id: number) {
    this.editId = id;
    this.orderDetailModalVisible = true;
  }

  hideOrderDetailModal() {
    this.orderDetailModalVisible = false;
  }

  showWithdrawModal(data:any){
    console.log('user:',data)
    this.withdrawUser=data;
    this.withdrawModal=true;
  }

  handleWithdraw(){
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("user/withdraw", {
              user_id: this.withdrawUser.id,
              money:values.money,
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.hideWithdrawModal();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }

  hideWithdrawModal(){
    this.withdrawModal=false
  }
}
